import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/PageHero";
import { Cases } from "@/components/Cases";
import { Testimonials } from "@/components/Testimonials";
import { CTASection } from "@/components/CTASection";
import { CASES } from "@/lib/data";

export default function CasesPage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: CASES.map((c, i) => ({
      "@type": "CreativeWork",
      position: i + 1,
      name: c.name,
      description: c.headline,
      url: `https://ldmedia.dk/cases/${c.slug}`,
    })),
  };

  return (
    <>
      <SEO
        title="Cases"
        path="/cases"
        description="Se hvordan LD Media har hjulpet danske virksomheder som Mr. Fried Chicken, Phonecycle, Dhaba Indian Kitchen, The Old Barber Lounge og Fatbike Eksperten med vækst online."
        jsonLd={jsonLd}
      />
      <PageHero
        eyebrow="Udvalgte Cases"
        title="Virksomheder vi har"
        accent="løftet."
        subtitle="Et udvalg af de virksomheder vi har arbejdet med — og hvordan vi har hjulpet dem med synlighed, content og vækst online."
      />
      <Cases showCta={false} hideHeading />
      <Testimonials />
      <CTASection title="Vil du være vores næste case?" />
    </>
  );
}
